/* PlansUserInputSection.tsx generated by @compiled/babel-plugin v0.36.0 */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
import { Box, media, xcss } from '@atlaskit/primitives';
import { Radio } from '@atlaskit/radio';
import Tooltip from '@atlaskit/tooltip';
import { BodyNormal, BodySmall } from '@atlassian/mpac-primitives';
import { NumericTextField } from '../../NumericTextField';
import { TooltipDialog } from '../common/TooltipDialog';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _8 = "._1jn41e6v.team-size-input{color:var(--ds-text-brand,#0c66e4)}";
const _7 = "._4t3i8pqr{height:2.5rem}";
const _6 = "._1bsb172j{width:6.25rem}";
const _5 = "._1yt4u2gc{padding:var(--ds-space-100,8px)}";
const _4 = "@media not all and (min-width:48rem){._8164xy5q{gap:var(--ds-space-400,2pc)}._1gde1bp4{flex-direction:column}._ag851y6m{align-items:flex-start}}";
const _3 = "._1wpz1fhb{align-self:stretch}";
const _2 = "._1bah1yb4{justify-content:space-between}";
const _ = "._1e0c1txw{display:flex}";
const displayFlex = xcss({
  display: 'flex'
});
const teamSizeBillingSection = null;
const flexCenter = xcss({
  display: 'flex',
  gap: 'space.200',
  alignItems: 'center'
});
const teamSizeInput = null;
const billingCycleOptions = [{
  value: 'monthlyPricingPlan',
  label: 'Monthly',
  name: 'productBillingCycle'
}, {
  value: 'annualPricingPlan',
  label: 'Annual',
  name: 'productBillingCycle'
}];
export const PlansUserInputSection = _ref => {
  let {
    teamSize,
    onTeamSizeChange,
    onBillingFrequencyChange,
    billingFrequency
  } = _ref;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsxs("div", {
      "data-testid": "plans-user-input-section",
      className: ax(["_1e0c1txw _1bah1yb4 _1wpz1fhb _8164xy5q _1gde1bp4 _ag851y6m"]),
      children: [/*#__PURE__*/_jsxs(Box, {
        xcss: flexCenter,
        children: [/*#__PURE__*/_jsx(BodyNormal, {
          children: "Team size:"
        }), /*#__PURE__*/_jsxs(Box, {
          xcss: displayFlex,
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_5, _6, _7, _8]
            }), /*#__PURE__*/_jsx(NumericTextField, {
              type: "text",
              pattern: "[0-9]+",
              min: 0,
              className: ax(["_1yt4u2gc _1bsb172j _4t3i8pqr _1jn41e6v", "team-size-input"]),
              value: teamSize === 0 ? '' : teamSize.toString(),
              onChange: onTeamSizeChange,
              isRounded: true,
              "aria-label": "Number of users in your product instance. Only numerical value can be entered with maximum limit being 20,000"
            })]
          }), /*#__PURE__*/_jsx(Tooltip, {
            component: TooltipDialog,
            content: "Enter the number of users specified for your instance in Settings > User Management.",
            position: "right",
            children: /*#__PURE__*/_jsx("span", {
              tabIndex: 0,
              children: /*#__PURE__*/_jsx(EditorPanelIcon, {
                label: "How to calculate the number of users?",
                size: "medium"
              })
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        xcss: flexCenter,
        children: [/*#__PURE__*/_jsx(BodyNormal, {
          children: "Billing frequency:"
        }), /*#__PURE__*/_jsx(Box, {
          xcss: flexCenter,
          children: billingCycleOptions.map(_ref2 => {
            let {
              value,
              label,
              name
            } = _ref2;
            return /*#__PURE__*/_jsx("span", {
              "aria-label": "Select ".concat(label, " billing cycle for your product"),
              children: /*#__PURE__*/_jsx(Radio, {
                value: value,
                label: /*#__PURE__*/_jsx(BodySmall, {
                  children: label
                }),
                name: name,
                isChecked: value === billingFrequency,
                onChange: onBillingFrequencyChange
              })
            }, value);
          })
        })]
      })]
    })]
  });
};